import * as React from 'react';
import { getCatalogRegistration } from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import { getLiveItemStatusOpen } from '@/redux/modules/liveItemStatus';
import { toast } from '@liveauctioneers/hammer-ui-core/toast';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

type Props = {
    catalogId: number;
    itemId: number;
};

const ItemBidToast = ({ catalogId, itemId }: Props) => {
    const { formatMessage } = useIntl();
    const [messageShown, setMessageShown] = React.useState(false);

    const { approved } = useAppSelector((state) => getCatalogRegistration(state, catalogId));
    const live = useAppSelector((state) => getLiveItemStatusOpen(state, itemId));

    React.useEffect(() => {
        if (window.localStorage && window.localStorage.liveItemBiddingMessageShown) {
            setMessageShown(true);
        }
    }, []);

    React.useEffect(() => {
        if (!messageShown && approved && live) {
            window.localStorage.liveItemBiddingMessageShown = true;
            setMessageShown(true);
            toast('success', {
                description: formatMessage({ id: 'toastMessage' }),
                title: formatMessage({ id: 'toastMessages.titles.success' }),
            });
        }
    }, [approved, live, messageShown, formatMessage]);

    return null;
};

export default React.memo<Props>(ItemBidToast);
